import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KeywordMetricsRequest } from './keyword-metrics-request';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GoogleKeywordService {

  constructor(private http: HttpClient) {
  }

  getKeywords(keywordMetricsRequest: KeywordMetricsRequest) {
    keywordMetricsRequest.startDate = keywordMetricsRequest.startDate?.toISOString ? keywordMetricsRequest.startDate.toISOString().split('T')[0] : keywordMetricsRequest.startDate;
    keywordMetricsRequest.endDate = keywordMetricsRequest.endDate?.toISOString ? keywordMetricsRequest.endDate.toISOString().split('T')[0] : keywordMetricsRequest.endDate;

    return this.http.post('/api/google/keywords', keywordMetricsRequest)
      .pipe(map((data: any) => data.rows));
  }
}
